import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {Ad} from "../../../interfaces/ad";
import {ActivatedRoute} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {CursorToken} from "../../../interfaces/utils";
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';
import { KazSearchComponent } from '../../../components/kaz-search/kaz-search.component';
import { KazFastSearchComponent } from '../../../components/kaz-fast-search/kaz-fast-search.component';
import { KazCardDefaultComponent } from '../../../components/kaz-card-default/kaz-card-default.component';
import { KazButtonComponent } from '../../../components/kaz-button/kaz-button.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-search-ad',
    templateUrl: './search-ad.component.html',
    styleUrls: ['./search-ad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, KazSearchComponent, KazFastSearchComponent, KazCardDefaultComponent, KazButtonComponent, FaIconComponent]
})
export class SearchAdComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _api = inject(ApiService);

  ads: Ad[] = [];

  pageSize: number = 24;
  search: string = '';
  nextToken: CursorToken = "@start";
  showEmpty: boolean = false;
  loadingAds: boolean = false;

  async ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.search = params['search'] ?? '';
      this.getSearchedAd().then();
    });
  }

  async getSearchedAd() {
    try {
      this.loadingAds = true;
      const data = await this._api.getSearchedAdList(this.search, '@start', this.pageSize);
      this.ads = data.ads;
      this.nextToken = data.nextPageToken;
      if (this.ads.length <= 0) this.showEmpty = true;
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingAds = false;
    }
  }

  async loadMore() {
    try {
      this.loadingAds = true;
      const data = await this._api.getSearchedAdList(this.search, this.nextToken, this.pageSize);
      this.ads = [...this.ads, ...data.ads];
      this.nextToken = data.nextPageToken;
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingAds = false;
    }
  }
}
